// pageIndex: 第幾頁
// pageSize:  一頁幾筆
// sortBy:  排序 int
export const initBookmark = sortBy => ({
	pageIndex: 1,
	pageSize : 50,
	sortBy   : sortBy || 1,
});

export const dialogTypeMap = {
	manualGift: "manualGift",
	workOut   : "workOut",
};

export const QUICK_ENUM = {
	workOut      : 1,   // 次數
	extension    : 2,   // 應續約
	leave        : 3,   // 請假
	invalid      : 4,   // 無效
	birthday     : 5,   // 生日
	hundredTShirt: 6,   // 百T
	newMember    : 7,   // 新會員
	healthCare   : 8,   // 健康產品
};

export const giftDispatchByMemberList   = [QUICK_ENUM.workOut, QUICK_ENUM.hundredTShirt, QUICK_ENUM.newMember, QUICK_ENUM.birthday];
export const membershipQuitByMemberList = [QUICK_ENUM.invalid, QUICK_ENUM.extension];
